import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import './bootstrap_custom.scss';
import './index.css';
import App from './components/App';
import { store } from './store';
import { ErrorBoundary } from './components/common/ErrorBoundary';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <ErrorBoundary>
        <Provider store={store}>
            <App />
        </Provider>
    </ErrorBoundary>
);
